import { FILE_QUESTION_TYPES } from "../components/activityQuestions/utils/questionTypes";

export const generateFilesFromActivityQuestions = (questionsByFollowUp, followUp, workOrderNumber) => {
    const mappedQuestions = questionsByFollowUp?.[followUp?.uuid]?.mappedQuestions;
    if (!Array.isArray(mappedQuestions) || mappedQuestions.length === 0) return [];
    const filteredQuestions = mappedQuestions.filter(
        (q) => FILE_QUESTION_TYPES.includes(q.questionType) && Array.isArray(q.value) && q.value.length > 0,
    );

    return filteredQuestions.flatMap((question) => {
        const files = Array.isArray(question?.value) ? question.value : [];
        return files.map((fileEntry) => {
            const baseName = (fileEntry?.fileName || "").trim();
            const ext = (fileEntry?.extension || "").trim();
            const fullName = fileEntry?.fullFileName || (baseName && ext ? `${baseName}.${ext}` : baseName);
            if (!baseName || baseName == "") return null;
            return {
                fullFileName: fullName,
                fileName: fullName,
                fileDescription: fileEntry?.fileDescription || "",
                fileType: fileEntry?.fileType || (ext ? `image/${ext}` : ""),
                data: fileEntry?.data || "",
                relatedJobId: workOrderNumber ?? null,
                relatedSourceId: followUp?.followUpId ?? null,
                workOrderNumber,
                followUpId: followUp?.id ?? null,
                followUpUuid: followUp?.uuid ?? null,
                ...(followUp.userName ? { uploadedBy: followUp.userName } : {}),
            };
        });
    });
};
